import React from 'react'
import PropTypes from 'prop-types'
import { areEqual, mapMaker } from './RowComponents'

let checkAreEqual = areEqual

const GenericSubRow = props => {
  if (props.structure.customMemoAreEqual) {
    checkAreEqual = props.structure.customMemoAreEqual
  }
  const myMap = mapMaker(props.structure.headers, props.structure.dataKeys)

  const fillSubRow = rowContent => {
    const filler = []
    myMap.forEach((value, key) => {
      let classes = 'cell'
      if (
        props.structure.rowFormat[value] &&
        props.structure.rowFormat[value].hasPriority
      ) {
        classes = classes + ' priority'
      }

      if (
        props.structure.rowFormat[value] &&
        props.structure.rowFormat[value].format
      ) {
        filler.push(
          <div key={value} className={classes}>
            {value && rowContent[value]
              ? props.structure.rowFormat[value].format(rowContent, value)
              : '-'}
          </div>
        )
      } else if (
        props.structure.rowFormat[value] &&
        props.structure.rowFormat[value].clickable
      ) {
        filler.push(
          <div key={key} className={classes}>
            <span
              className="modalLink"
              data={rowContent[value]}
              onClick={() =>
                props.structure.rowFormat[value].clickable(rowContent)
              }
            >
              {props.structure.rowFormat[value].name(rowContent[value]) || '-'}
            </span>
          </div>
        )
      } else {
        filler.push(
          <div key={key} className={classes}>
            {value && rowContent[value] ? rowContent[value] : '-'}
          </div>
        )
      }
    })

    return filler
  }
  const clickHandler = e => {
    e.stopPropagation()
    if (props.callBack) {
      props.callBack()
    }
  }

  if (props.structure.customContent) {
    return props.rowContent
  }

  return (
    <div
      data-testid="genericSubRow"
      key={props.index}
      className="subMenu-row"
      onClick={e => clickHandler(e)}
    >
      {fillSubRow(props.rowContent)}
    </div>
  )
}

export default React.memo(GenericSubRow, checkAreEqual)

GenericSubRow.propTypes = {
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  callBack: PropTypes.func,
  rowContent: PropTypes.object,
  structure: PropTypes.shape({
    rowFormat: PropTypes.object,
    headers: PropTypes.array,
    dataKeys: PropTypes.array,
    customMemoAreEqual: PropTypes.func
  })
}
